module.exports = __webpack_public_path__ + "img/ios-globe.f74670c8.svg";